module.exports = __webpack_public_path__ + "img/baseline-clear-24px.f7db365c.svg";